import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'
import basePropTypes from './types'

export const Select = ({
  open = false,
  placeholder = 'Choose an option',
  disabled,
  options,
  label,
  active,
  innerRef,
  onClicks = {},
  cssClassNames = {},
  children,
  dataTestId,
  buttonDataTestId,
}) => {
  const activeOption = options.find(active)
  const activeLabel = (activeOption && label(activeOption)) || placeholder

  return (
    <div
      ref={innerRef}
      className={classNames(cssClassNames.wrapper, style.group, {
        [style.disabled]: disabled,
      })}
    >
      <button
        className={classNames(cssClassNames.trigger, style.trigger)}
        data-test-id={buttonDataTestId}
        onClick={onClicks.trigger}
      >
        {activeLabel}
      </button>

      <ul
        className={classNames(style.options, {
          [style.showing]: open,
        })}
        role="menu"
      >
        {options.map((option, i) => (
          <li
            className={classNames(cssClassNames.option, style.option, {
              [style.active]: active(option),
            })}
            data-test-id={dataTestId}
            key={`option-${i}`}
          >
            {children({ option, onClick: onClicks.option })}
          </li>
        ))}
      </ul>
    </div>
  )
}

Select.propTypes = {
  ...basePropTypes,
  open: PropTypes.bool.isRequired,
  innerRef: PropTypes.func,
  onClicks: PropTypes.shape({
    trigger: PropTypes.func,
    option: PropTypes.func,
  }),
  dataTestId: PropTypes.string,
  buttonDataTestId: PropTypes.string,
}

export default Select
